module.exports = __webpack_public_path__ + "img/scammer_2.8f3319d2.png";